import { logout } from '@/api/login'
import { ScalrDatePicker } from '@/components/customComponents/ScalrDatePicker'
import { Button } from '@/components/ui/button'
import { DateType } from '@/utils/date'
import { useCallback, useState } from 'react'
import { DateRange } from 'react-day-picker'

export default function SettingsPage() {
  const handleLogout = async () => {
    await logout()
  }

  const [pendingDate, setPendingDate] = useState<DateRange | undefined>(
    undefined
  )
  const [pendingDateFilterType, setPendingDateFilterType] =
    useState<DateType>('month-to-date')

  const handleDateChange = useCallback(
    (newDate: DateRange | undefined, newDateFilterType: DateType) => {
      console.log(
        'Date selection changed (pending):',
        newDate,
        newDateFilterType
      )
      setPendingDate(newDate)
      setPendingDateFilterType(newDateFilterType)
    },
    []
  )

  return (
    <div className="p-4">
      <ScalrDatePicker
        date={pendingDate}
        dateFilterType={pendingDateFilterType}
        onChange={handleDateChange}
      />
      <Button onClick={handleLogout} variant="destructive">
        Logout
      </Button>
    </div>
  )
}
